<template>
    <div class="h-full overflow-y-auto">
        <sub-account-ledger :sub-account-getter="getAccountsPayable" :is-customer="false"/>
    </div>
</template>

<script setup lang="ts">
import {useSubAccounts} from '@/subaccount/subAccount.service'
import SubAccountLedger from '@/subaccount/outstandingBalance/SubAccountLedger.vue'

const {getAccountsPayable} = useSubAccounts()


</script>